__webpack_require__.p = "/futbl/";